export const FETCH_FORMS_REQUEST = 'FETCH_FORMS_REQUEST';
export const FETCH_FORMS_SUCCESS = 'FETCH_FORMS_SUCCESS';
export const FETCH_FORMS_FAILED = 'FETCH_FORMS_FAILED';
